import './App.css';
import Navbar from './components/common/Navbar';
import { Route, Routes, useNavigate } from "react-router-dom";
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Error from './pages/Error';
import CourseDetails from './pages/CourseDetails';
import CourseDetailsDevops from './pages/CourseDetailsDevOps'
import CourseDetailsITIL from './pages/CourseDetailsITIL'
import CourseDetailsSIAM from './pages/CourseDetailsSIAM'
import CourseDetailsPMP from './pages/CourseDetailsPMP'
import CourseDetailsPrince from './pages/CourseDetailsPrince'
import CourseDetailsAWS from './pages/CourseDetailsAWS'
import CourseDetailsAzure from './pages/CourseDetailsAzure';
import Scroll_To_Top_Button from './utils/Scroll_To_Top_Button';
import Careers from './pages/Careers';
import Chatbot from './utils/Chatbot_query.jsx'
import { useScrollToTop } from './utils/useScrollToTop';
import DBAGuidancePage from './pages/DBA.jsx';
import KennedyUniversityPhD from './pages/ResearchPhD.jsx';
import KennedyUniversityHonoraryPhD from './pages/HonararyPhD.jsx';
import ThesisWritingService from './pages/ThesisWriting.jsx';
import DissertationService from './pages/Dissertation.jsx';
import PaperPublicationSupport from './pages/PaperPublicationSupport.jsx';
import WritingService from './pages/WritingServices.jsx';
import DocumentationSupport from './pages/DocumentationSupport.jsx';
import Blogs from './pages/Blogs.jsx';
import BlogPost from './pages/BlogPost.jsx';

function App() {
  useScrollToTop();

  return (
    <div className="w-screen min-h-screen bg-richblack-900 flex flex-col font-inter">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blogs />} />
        <Route path="/blog/:id" element={<BlogPost />} />
        <Route path="courses/sre-foundation" element={<CourseDetails />} />
        <Route path="courses/devops-foundation" element = {<CourseDetailsDevops />}/>
        <Route path="courses/itil-4-foundation" element = {<CourseDetailsITIL />}/>
        <Route path="courses/siam-foundation" element = {<CourseDetailsSIAM />}/>
        <Route path="courses/pmp-training" element = {<CourseDetailsPMP />}/>
        <Route path="courses/prince2®-foundation" element = {<CourseDetailsPrince />}/>
        <Route path="courses/aws-solution-architect-associates" element = {<CourseDetailsAWS />}/>
        <Route path="courses/microsoft-azure-architect-304" element = {<CourseDetailsAzure />}/>
        <Route path="/careers" element = {<Careers />}/>
        <Route path="/dba" element = {<DBAGuidancePage/>}/>
        <Route path="/phd/phd-admission" element = {<KennedyUniversityPhD/>}/>
        <Route path="/phd/honarary-phd" element = {<KennedyUniversityHonoraryPhD/>}/>
        <Route path="/phd/thesis-writing" element = {<ThesisWritingService/>}/> 
        <Route path="/phd/dissertation" element = {<DissertationService/>}/>
        <Route path="/phd/paper-publication" element = {<PaperPublicationSupport/>}/>
        <Route path="/phd/writing-services" element={<WritingService/>}/>
        <Route path="/phd/documentation-support" element={<DocumentationSupport/>}/>
        {/* <Route path="*" element={<Error />} /> */}
      </Routes>
      {/* <Scroll_To_Top_Button/> */}
      <Chatbot/>
    </div>
  );
}

export default App;
